const extraDiscountRequest = history => {
	history.push('/wishlist/condition-request');
};

export default extraDiscountRequest;
